import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { EquipmentDocument } from '../Equipment/queryBuilder';
import { LocationDocument } from '../Locations/queryBuilder';
import { MiningCutDocument } from '../MiningCut/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  ProductionDocument,
  productionPullQueryBuilder,
  productionPushQueryBuilder,
} from './queryBuilder';

export function borerShiftProductionFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember<BorerShiftDocument>,
  equipment: FamilyMember<EquipmentDocument>,
  locations: FamilyMember<LocationDocument>,
  miningCuts: FamilyMember<MiningCutDocument>,
): FamilyMember<ProductionDocument> {
  const syncConfig = configBuilder<ProductionDocument>(RxdbCollectionNameV2.BORER_SHIFT_PRODUCTION);
  doNotAutoSync(syncConfig);

  pull(syncConfig, productionPullQueryBuilder);
  push(syncConfig, productionPushQueryBuilder);
  syncConfig.retryTime = 7500;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_PRODUCTION, replicationState, [
    borerShift,
    equipment,
    locations,
    miningCuts,
  ]);
}
